<!-- Discussion List-->
<div class="card-columns">
  <discussion-preview
    *ngFor="let discussion of results"
    [discussion]="discussion"
    [query]="query"
    (setTagTo)="setTagTo($event)"
  ></discussion-preview>
</div>

<!-- Loader spinner -->
<loader-animation [loading]="loading" [message]="'Loading nDabas'">
</loader-animation>
<!-- Loader spinner -->

<!-- No content message-->
<no-content-msg
  [hidden]="loading || results.length"
  [message]="'No nDabas here yet'"
>
</no-content-msg>
<!-- No content message -->

<!-- Pagination -->
<pagination-buttons
  [currentPage]="currentPage"
  [loading]="loading"
  [showNavBar]="true"
  [smallButtons]="false"
  [totalPageCount]="totalPages"
  (setPageTo)="setPageTo($event)"
>
</pagination-buttons>
<!-- Pagination -->
